import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login'
import LoginCopy from "@/views/loginCopy";
import Profile from '@/views/profile'
import Result from '@/views/result'
//客户面谈评价登录
import ContactEvaluateLogin from '@/views/contactEvaluateLogin'
import Evaluate from '@/views/evaluate'
import EvaluateResult from '@/views/evaluateResult'
//日本渠道活动
import ChannelDetail from '@/views/channelDetail'
import SignRegister from '@/views/sign_register'
import SignResult from '@/views/signResult'
import PaymentSuccess from '@/views/paymentSuccess'
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/loginCopy',
      name: 'loginCopy',
      component: LoginCopy
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/result',
      name: 'result',
      component: Result
    },
    {
      path: '/contactEvaluateLogin',
      name: 'contactEvaluateLogin',
      component: ContactEvaluateLogin
    },
    {
      path: '/evaluate',
      name: 'evaluate',
      component: Evaluate
    },
    {
      path: '/evaluateResult',
      name: 'evaluateResult',
      component: EvaluateResult
    },
    {
      path: '/channelDetail',
      name: 'channelDetail',
      component: ChannelDetail
    },
    {
      path: '/signRegister',
      name: 'signRegister',
      component: SignRegister
    },
    {
      path: '/signResult',
      name: 'signResult',
      component: SignResult
    },
    {
      path: '/paymentSuccess',
      name: 'paymentSuccess',
      component: PaymentSuccess
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js